$('.input-group').on('click', 'i.icon-eye', function() {
  const $this = $(this);
  const isActive = $this.hasClass('active');

  $this
    .toggleClass('active', !isActive)
    .closest('.input-group')
    .find('input')
    .attr('type', isActive ? 'password' : 'text');

  return false;
});



// WEBPACK FOOTER //
// app/javascript/common/show-password.js